import React, { useState, useEffect } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import '../AdminServiceEditor/AdminServiceEditor.css';

const AdminEventEditor = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const isNew = id === 'new';

    const [formData, setFormData] = useState({
        title: '',
        description: '',
        event_date: '',
        event_time: '',
        location: '',
        image_url: '',
        thumb_url: '',
        sort_order: 0
    });
    const [loading, setLoading] = useState(!isNew);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        const token = localStorage.getItem('pcic_admin_token');
        if (!token) {
            navigate('/admin');
            return;
        }

        if (!isNew) {
            fetchEvent();
        }
    }, [id, isNew, navigate]);

    const fetchEvent = async () => {
        try {
            const res = await fetch(`/api/events/${id}`);
            const data = await res.json();
            setFormData(data);
        } catch (error) {
            alert('Error loading event');
            navigate('/admin/dashboard');
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSaving(true);

        try {
            const url = isNew ? '/api/events' : `/api/events/${id}`;
            const method = isNew ? 'POST' : 'PUT';

            const res = await fetch(url, {
                method,
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData)
            });

            if (res.ok) {
                navigate('/admin/dashboard');
            } else {
                const error = await res.json();
                alert(error.message || 'Error saving event');
            }
        } catch (error) {
            alert('Error saving event');
        } finally {
            setSaving(false);
        }
    };

    if (loading) {
        return <div className="admin-loading">Loading...</div>;
    }

    return (
        <div className="admin-editor">
            <header className="editor-header">
                <Link to="/admin/dashboard" className="back-link">← Back to Dashboard</Link>
                <h1>{isNew ? 'Add New Event' : 'Edit Event'}</h1>
            </header>

            <form onSubmit={handleSubmit} className="editor-form">
                <div className="form-group">
                    <label>Title *</label>
                    <input
                        type="text"
                        name="title"
                        value={formData.title}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className="form-group">
                    <label>Description</label>
                    <textarea
                        name="description"
                        value={formData.description}
                        onChange={handleChange}
                        rows={6}
                    />
                </div>

                <div className="form-row">
                    <div className="form-group">
                        <label>Event Date</label>
                        <input
                            type="date"
                            name="event_date"
                            value={formData.event_date}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="form-group">
                        <label>Event Time</label>
                        <input
                            type="text"
                            name="event_time"
                            value={formData.event_time}
                            onChange={handleChange}
                            placeholder="e.g., 7:00 PM - 9:00 PM"
                        />
                    </div>
                </div>

                <div className="form-group">
                    <label>Location</label>
                    <input
                        type="text"
                        name="location"
                        value={formData.location}
                        onChange={handleChange}
                    />
                </div>

                <div className="form-group">
                    <label>Image URL</label>
                    <input
                        type="text"
                        name="image_url"
                        value={formData.image_url}
                        onChange={handleChange}
                    />
                </div>

                <div className="form-group">
                    <label>Thumbnail URL</label>
                    <input
                        type="text"
                        name="thumb_url"
                        value={formData.thumb_url}
                        onChange={handleChange}
                    />
                </div>

                <div className="form-group">
                    <label>Sort Order</label>
                    <input
                        type="number"
                        name="sort_order"
                        value={formData.sort_order}
                        onChange={handleChange}
                    />
                </div>

                <div className="form-actions">
                    <button type="submit" disabled={saving} className="save-btn">
                        {saving ? 'Saving...' : 'Save Event'}
                    </button>
                    <Link to="/admin/dashboard" className="cancel-btn">Cancel</Link>
                </div>
            </form>
        </div>
    );
};

export default AdminEventEditor;
